<template lang="pug">
.do-MYOFFICE
  div.mask1.maskoffice(@click="start",v-if="state===0")
  div.top-nav
      div.left-nav
        img.logo(:src="logoNav")
        li(v-for='(v,idx) in list',:class="{active:idx===0}",@click="start").text {{v}}
      div(style='flex:1;')
      div.rigth-nav
        i.icon-renwu1.iconfont(style='padding-right:8px;')
        p.task-text 任务
        p.task-text(style='color:#D8D8D8;padding-right: 8px;padding-left: 26px;') |
        p.task-text 退出实训
  .roomTitle(v-once) 我的办公室
    div.tl().point
    div.tr().point
    div.bl().point
    div.br().point
  div(v-if="state===0")
    img(src="../../assets/Noviceguide/小手.png", alt="提示",style="left:18%").finger
    div.text-Explain(style="z-index: 55555666;left: 375px;top: 23%;") 点击标有红色的任务
  ul.list
    li(v-for='(v,idx) in list1',:class="{'active-do':idx===0}")
      i.icon-labelb.iconfont.icon
      | {{v.functionName}}
      Badge.point(dot,v-if="idx===0")
  fillbLanks(v-if="state===1",@start="start")
  div.mask1.masktask(@click="start",v-if="state===2")
  div(v-if="state===2")
    img(src="../../assets/Noviceguide/小手.png", alt="提示").finger1
    div.text-Explain(style="z-index: 55556566;left: 262px;top: 13%;") 点击阶段
  div(v-if="state===3")
    img(src="../../assets/Noviceguide/小手.png", alt="提示").finger2
    div.text-Explain(style="z-index: 55556566;left: 361px;top: 34%;") 点击已完成任务可以返回查看（任务前有 “
      Icon(type="ios-checkmark",size="16",color="#F5A623",style="left: 138px;")
      span “，表示该任务已完成）
  //- div.mask1(@click="start",v-if="state===3")
  zxDrawer(align="up",:closeable="true",:z-index="999999")
        div(v-if="state===3").drawer-Statr
          ul(style="left: 138px;")
            li(v-for="(item,idx) in completeTaskList",:class="{'active':3 === idx}",@click="start").name
              Icon(type="ios-checkmark",size="16",color="#F5A623",style="left: 138px;",v-if="item.complete")
              div(v-else,style="left: 148px;width: 20px;display: inline-block;")
              span  {{item.taskName}}
  right-column
</template>
<script>
import Drawer from "vue-simple-drawer";
import rightColumn from "@/components/doCase/RightColumn"; // 右侧按钮控件
import fillbLanks from "./FILLBLANKS";
export default {
  components: {
    rightColumn,
    fillbLanks,
    zxDrawer: Drawer
  },
  data() {
    return {
      state: 0,
      list: ["政策制定", "政策执行", "政策评估", "政策终结"],
      completeTaskList: [
        { complete: true, taskName: "问题查觉" },
        { complete: true, taskName: "撰写调研计划" },
        { complete: true, taskName: "实施调研" },
        { complete: true, taskName: "问题认定" },
        { complete: false, taskName: "政策方案的规划与抉择" },
        { complete: false, taskName: "政策内容讨论" }
      ],
      list1: [
        { functionName: "制定调研计划" },
        { functionName: "政策问题界定" },
        { functionName: "我的文档" }
      ]
    };
  },
  methods: {
    start() {
      this.state += 1;
      if (this.state > 3) {
        this.$emit("start");
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import 'css.styl'
.drawer-Statr
  text-align left
  .active
    color #ffffff !important
    font-weight bold
  ul
    width 334px
    position relative
    display inline-block
    .name
      cursor pointer
      margin 24px
      font-size 14px
      font-family MicrosoftYaHeiUI
      color #d7d7d7
      line-height 18px
@keyframes myfirst1
  from
    left 195px
    top 4%
  to
    left 220px
    top 5%
.finger1
  // transition 1s
  animation myfirst1 0.5s infinite
  animation-direction alternate
  position absolute
  right 2px
  z-index 55555556
@keyframes myfirst2
  from
    left 234px
    top 28%
  to
    left 254px
    top 30%
.finger2
  // transition 1s
  animation myfirst2 0.5s infinite
  animation-direction alternate
  position absolute
  z-index 55555556
  left 14%
  top 30%
.masktask
  width 80px
  height 40px
  z-index 9999999
  left 195px
  top 1.6%
  cursor pointer
  border 1px solid #5f5c5c
.maskoffice
  width 220px
  height 48px
  z-index 9999999
  left 193px
  top 10.6%
  cursor pointer
.active-do
  background #ffffff !important
.do-MYOFFICE
  position absolute
  background url('../../assets/case/department/myOffice.png')
  background-size 100vw
  height 100vh
  width 100vw
  z-index 5
  .roomTitle
    position absolute
    top 76px
    left 0
    right 0
    margin 0 auto
    width 150px
    height 40px
    background-color rgba(245, 166, 35, 1)
    border-radius 4px
    opacity 0.8022
    font-size 18px
    font-family fzhpfw
    font-weight normal
    color rgba(255, 255, 255, 1)
    line-height 40px
    .point
      width 4px
      height 4px
      background rgba(255, 255, 255, 1)
      border-radius 2px
      opacity 0.3043
      &:nth-child(1)
        position absolute
        top 4px
        left 6px
      &:nth-child(2)
        position absolute
        top 4px
        right 6px
      &:nth-child(3)
        position absolute
        top 30px
        left 6px
      &:nth-child(4)
        position absolute
        top 30px
        right 6px
  .list
    display flex
    height 80%
    position absolute
    top 0
    bottom 0
    margin auto
    left 145px
    flex-flow column
    .icon
      color #FF9F00
      font-size 24px
      margin-left 15px
      margin-right 15px
    li
      margin-bottom 16px
      cursor pointer
      width 220px
      text-align left
      height 48px
      background rgba(220, 230, 242, 1)
      box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.2)
      border-radius 8px
      font-size 16px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.8)
      line-height 48px
      position relative
  .point
    position absolute
    right 20px
    top 15px
</style>
